import { render, staticRenderFns } from "./ProfileAbout.vue?vue&type=template&id=21d1ee99&scoped=true"
import script from "./ProfileAbout.vue?vue&type=script&lang=js"
export * from "./ProfileAbout.vue?vue&type=script&lang=js"
import style0 from "./ProfileAbout.vue?vue&type=style&index=0&id=21d1ee99&prod&lang=scss&scoped=true"
import style1 from "./ProfileAbout.vue?vue&type=style&index=1&id=21d1ee99&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d1ee99",
  null
  
)

export default component.exports